<template lang="">
    <div class="contents">
        <div class="customer_wrap">
            <div class="cs_card">
                <div class="box">
                    <img src="../../assets/images/common/ico_cs.png" alt="고객센터 이용안내">
                    <p>고객센터 이용안내</p>
                    <h5>070.4233.0655</h5>
                    <span>FAX : 02)478-5822</span>
                </div>
                <p>운영시간</p>
                <span>월-금 09:00~17:30</span>
            </div>
            <div class="cs_tab">
                <CustomerServiceNavigation/>
                <div class="cs_tabPanel active" id="cs_tab04">
                    <h5 class="title">이용약관</h5>
                    <div class="use_wrap">
                        <div class="tit">
                            제 1조 (목적)
                        </div>
                        <p class="txt">
                            본 약관은 디지털로고스 디지털 화환 서비스(이하 ‘회사’라 함)가 운영하는 디지털로고스(이하 ‘몰’이라 함)에서 제공하는 <br>
                            인터넷 관련 서비스를 이용함에 있어 ‘몰’과 ‘이용자’의 권리·의무 및 책임사항을 규정함을 목적으로 합니다.
                        </p>
                        <div class="tit">
                            제 2조 [용어의 정의]
                        </div>
                        <p class="txt">
                            본 약관에서 사용하는 용어의 정의는 다음과 같습니다. <br>
                            1. "몰"이란 회사가 재화 또는 용역(이하 "재화 등"이라고 합니다)을 이용자에게 제공하기 위하여 컴퓨터, 핸드폰 등 정보통신설비를 이용하여 재화 또는 <br>
                            용역 등을 거래할 수 있도록 설정한 가상의 영업장을 말하며, 아울러 사이버몰을 운영하는 사업자의 의미로도 사용합니다. <br>
                            2. "이용자"란 "몰"에 접속하여 이 약관에 따라 "몰"이 제공하는 서비스를 받는 회원 및 비회원을 말합니다. <br>
                            3. "회원"이라 함은 "몰"에 개인정보를 제공하여 회원가입을 한 자로서, "몰"의 정보를 지속적으로 제공받으며, "몰"이 제공하는 서비스를 계속적으로 <br>
                            이용할 수 있는 자를 말합니다. <br>
                            4. "비회원"이라 함은 회원에 가입하지 않고 "몰"이 제공하는 서비스를 이용하는 자를 말합니다. <br>
                            5. "적립금"이란 "몰"이 특정 재화 등을 구입한 이용자 또는 경품 등의 목적으로 이용자에게 부여한 사이버머니를 말하며, 적립금의 부여 및 사용 등과 <br>
                            관련한 사항은 이 약관 또는 "몰"의 운영정책이 정한 바에 따릅니다. <br>
                            6. 서비스 : 회사가 제공하는 인터넷상의 모든 서비스를 말합니다. <br>
                            7. 아이디 : 회원의 식별과 회원의 서비스이용을 위하여 문자나 숫자 혹은 그 조합을 말합니다(이하 "ID"라 합니다). <br>
                            8. 비밀번호 : 회원이 부여 받은 ID와 일치된 회원임을 확인하고, 회원의 권익 및 비밀보호를 위하여 회원 스스로가 선정하여 “몰”에 등록한 문자와 <br>
                            숫자의 조합을 말합니다. <br>
                            9. 서비스제공 제한·중지 : 공공의 이익 규정에 위배되는 경우에 회원에게 제공하는 서비스의 전부 또는 일부를 제한하거나 중지하는 것을 말합니다.
                        </p>
                        <div class="tit">
                            제 29조 【분쟁의 해결】
                        </div>
                        <p class="txt">
                            ① 회사와 회원은 서비스와 관련하여 분쟁이 발생한 경우에 이를 원만하게 해결하기 위하여 필요한 모든 노력을 하여야 합니다. <br>
                            ② 제1항의 규정에도 불구하고, 동 분쟁으로 인하여 소송이 제기될 경우 동 소송은 제소 당시의 이용자의 주소에 의하고, 주소가 없는 경우에는 거소를 관할하는 <br>
                            지방법원의 전속관할로 합니다. 다만, 제소 당시 이용자의 주소 또는 거소가 분명하지 않거나 외국 거주자의 경우에는 민사소송법상의 관할법원에 제기합니다. <br>
                            ③ "회사"와 이용자간에 제기된 전자상거래 소송에는 한국법을 적용합니다.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CustomerServiceNavigation from '@/views/customerService/layout/CustomerServiceNavigation.vue';

export default {
    components: {
        CustomerServiceNavigation
    }
}
</script>
<style lang="">

</style>